import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal", "searchInput", "menuList", "hiddenInput", "selectedName"]
  static values = { menus: Array }

  connect() {
    this.filteredMenus = this.menusValue
  }

  openModal(event) {
    event.preventDefault()
    this.modalTarget.showModal()
    this.searchInputTarget.value = ""
    this.filterMenus()
    // 포커스를 검색 필드로
    setTimeout(() => this.searchInputTarget.focus(), 100)
  }

  closeModal() {
    this.modalTarget.close()
  }

  filterMenus() {
    const query = this.searchInputTarget.value.toLowerCase().trim()

    if (query === "") {
      this.filteredMenus = this.menusValue
    } else {
      this.filteredMenus = this.menusValue.filter(menu =>
        menu.name.toLowerCase().includes(query)
      )
    }

    this.renderMenuList()
  }

  renderMenuList() {
    const currentMenuId = parseInt(this.hiddenInputTarget.value, 10)

    if (this.filteredMenus.length === 0) {
      this.menuListTarget.innerHTML = `
        <div class="p-4 text-center text-gray-500">
          검색 결과가 없습니다.
        </div>
      `
      return
    }

    this.menuListTarget.innerHTML = this.filteredMenus.map(menu => `
      <button type="button"
              class="w-full text-left px-4 py-3 hover:bg-gray-100 transition-colors flex items-center justify-between ${menu.id === currentMenuId ? 'bg-primary/10' : ''}"
              data-action="click->menu-search#selectMenu"
              data-menu-id="${menu.id}"
              data-menu-name="${menu.name}">
        <span class="font-medium">${menu.name}</span>
        ${menu.id === currentMenuId ? '<svg class="w-5 h-5 text-primary" fill="currentColor" viewBox="0 0 20 20"><path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd"/></svg>' : ''}
      </button>
    `).join('')
  }

  selectMenu(event) {
    const menuId = event.currentTarget.dataset.menuId
    const menuName = event.currentTarget.dataset.menuName

    // hidden input 업데이트
    this.hiddenInputTarget.value = menuId

    // 선택된 메뉴 이름 표시
    this.selectedNameTarget.textContent = menuName

    // 모달 닫기
    this.closeModal()

    // change 이벤트 발생시켜 재료 계산 트리거
    this.hiddenInputTarget.dispatchEvent(new Event('change', { bubbles: true }))
  }

  // ESC 키로 모달 닫기
  handleKeydown(event) {
    if (event.key === "Escape") {
      this.closeModal()
    }
  }

  // 모달 외부 클릭 시 닫기
  handleBackdropClick(event) {
    if (event.target === this.modalTarget) {
      this.closeModal()
    }
  }
}
